import axios from "../axios";
import config from "@/utils/global.js";
export const timerPost = (data) => {
  return axios({
    hostUrl: config.timerUrl,
    url: data.url,
    method: 'post',
    data: data.data
  })
}
export const timerGet = (data) => {
  return axios({
    hostUrl: config.timerUrl,
    url: data.url,
    method: 'get',
    data: data.data
  })
}
export const timerDelete = (data) => {
  return axios({
    hostUrl: config.timerUrl,
    url: data.url,
    method: 'delete',
    data: data.data
  })
}

// 获取任务类
export const getClassName = (data) => {
  return axios({
    hostUrl: config.timerUrl,
    url: data.url,
    method: 'get',
    data: data.data
  })
}



// WEBPACK FOOTER //
// ./src/http/moudules/wisdom.js